import { AlertTriangle, BellRing, ShieldCheck } from "lucide-react";
import StatusBadge from "./StatusBadge";

const ICONS = {
  waarschuwing: AlertTriangle,
  "let-op": BellRing,
  compliance: ShieldCheck,
};

export default function SignalCard({ signal }) {
  const Icon = ICONS[signal.type] || BellRing;

  return (
    <div className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm">
      <div className="mb-2 flex items-start justify-between gap-2">
        <div className="flex items-center gap-2">
          <Icon size={16} className="text-slate-600" />
          <h4 className="text-sm font-semibold text-slate-900">{signal.titel}</h4>
        </div>
        <StatusBadge value={signal.type} />
      </div>
      <p className="text-sm text-slate-600">{signal.omschrijving}</p>
    </div>
  );
}
